// Seeded to-do ids whose web forms render instructions.
export const INSTRUCTIONS_TODO_IDS = {
  internStatementOfPurpose: "80ee1b3a-c21c-47b1-9bd4-d074ca5f4819",
  courseForm: "de59a5f0-a72d-4570-ae98-b6a2ab790229",
  statementOfPurpose: "7c585fab-6517-470c-8d9d-7bb0a2e87949",
} as const;
